var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { value: _vm.value, persistent: "", width: "1200" },
      on: {
        "click:outside": function($event) {
          return _vm.close()
        }
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "pl-5 pr-2 pt-4 pb-2" },
            [
              _c("div", { staticClass: "title h6" }, [
                _vm._v(" Complex Promo Merging ")
              ]),
              _c(
                "v-card-subtitle",
                { staticClass: "pa-0 ma-0", attrs: { width: "100" } },
                [
                  _vm._v(" Select up to 10 eligible promotions for merging. "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "ml-2 mr-2",
                      attrs: { text: "" },
                      on: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [_vm._v(" Cancel ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "ma-0",
                      attrs: {
                        color: "primary",
                        disabled:
                          _vm.selectedEligiblePromos.length === 0 || _vm.loading
                      },
                      on: {
                        click: function($event) {
                          _vm.confirmationModal = true
                        }
                      }
                    },
                    [_vm._v(" Merge ")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("v-divider", { staticClass: "mx-4" }),
          _c(
            "v-container",
            { staticClass: "pa-0", attrs: { fluid: "" } },
            [
              _c("v-data-table", {
                staticClass: "mx-4",
                attrs: {
                  items: _vm.eligiblePromos,
                  headers: _vm.headers,
                  "show-select": "",
                  "no-data-text": "No eligible promotions",
                  dense: "",
                  "item-key": "promo_id",
                  "fixed-header": "",
                  loading: _vm.loading,
                  height: _vm.tableHeight,
                  "footer-props": { "items-per-page-options": [-1] },
                  "items-per-page": -1
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "item.start_dt",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          item.start_dt
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$config.formatDate(item.start_dt))
                                )
                              ])
                            : _c("span", [_vm._v("-")])
                        ]
                      }
                    },
                    {
                      key: "item.end_dt",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          item.end_dt
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$config.formatDate(item.end_dt))
                                )
                              ])
                            : _c("span", [_vm._v("-")])
                        ]
                      }
                    },
                    {
                      key: "item.updated_on",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          item.updated_on
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$config.formatTimestamp(item.updated_on)
                                  )
                                )
                              ])
                            : _c("span", [_vm._v("-")])
                        ]
                      }
                    }
                  ],
                  null,
                  true
                ),
                model: {
                  value: _vm.selectedEligiblePromos,
                  callback: function($$v) {
                    _vm.selectedEligiblePromos = $$v
                  },
                  expression: "selectedEligiblePromos"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { width: "400" },
          model: {
            value: _vm.confirmationModal,
            callback: function($$v) {
              _vm.confirmationModal = $$v
            },
            expression: "confirmationModal"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { flat: "" } },
            [
              _c("v-card-title", [_vm._v("Confirm Merge")]),
              _c("v-card-text", { staticClass: "pb-0" }, [
                _vm._v(
                  " Are you sure that you would like to merge with the selected promotions? "
                )
              ]),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-col",
                    [
                      !_vm.isMergedPromo
                        ? _c(
                            "v-row",
                            [
                              _c("v-text-field", {
                                staticClass: "mx-6",
                                attrs: {
                                  label: "Merged Promo Name",
                                  dense: "",
                                  "background-color": "#fff",
                                  outlined: "",
                                  rules: [
                                    function(v) {
                                      return !!v || "Promotion name is required"
                                    },
                                    _vm.validateText
                                  ]
                                },
                                model: {
                                  value: _vm.mergedPromoName,
                                  callback: function($$v) {
                                    _vm.mergedPromoName = $$v
                                  },
                                  expression: "mergedPromoName"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "v-row",
                        [
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mr-4 mb-2",
                              on: {
                                click: function($event) {
                                  _vm.confirmationModal = false
                                }
                              }
                            },
                            [_vm._v(" Cancel ")]
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "white--text mb-2",
                              attrs: {
                                color: "success",
                                disabled:
                                  !_vm.isMergedPromo && !_vm.mergedPromoName
                              },
                              on: {
                                click: function($event) {
                                  return _vm.merge()
                                }
                              }
                            },
                            [_vm._v(" Confirm ")]
                          ),
                          _c("v-spacer")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { width: "600" },
          model: {
            value: _vm.missingPartiesModal,
            callback: function($$v) {
              _vm.missingPartiesModal = $$v
            },
            expression: "missingPartiesModal"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { flat: "" } },
            [
              _c("v-card-title", [_vm._v("Promo Party Mismatch")]),
              _c("v-card-text", { staticClass: "pb-0" }, [
                _vm._v(
                  " One or more of the selected promotions' stores or ad groups do not match the current promo. "
                )
              ]),
              _c(
                "v-card-actions",
                { staticClass: "pt-0" },
                [
                  _c(
                    "v-col",
                    [
                      _c("v-subheader", [
                        _vm._v("Promos With Differing Parties")
                      ]),
                      _c(
                        "v-container",
                        {
                          staticClass: "py-0 overflow-y-auto",
                          staticStyle: { "max-height": "160px" }
                        },
                        [
                          _c(
                            "v-card",
                            [
                              _c(
                                "v-list",
                                { attrs: { flat: "", nav: "", dense: "" } },
                                [
                                  _c(
                                    "v-list-item-group",
                                    { attrs: { color: "primary" } },
                                    _vm._l(
                                      _vm.promosWithMissingParties,
                                      function(promo) {
                                        return _c(
                                          "v-list-item",
                                          {
                                            key: promo.promo_id,
                                            on: {
                                              click: function($event) {
                                                return _vm.goToPromo(
                                                  promo.promo_id
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(promo.promo_name) +
                                                " "
                                            )
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("v-subheader", [_vm._v("Differing Parties")]),
                      _c(
                        "v-container",
                        {
                          staticClass: "py-0 overflow-y-auto",
                          staticStyle: { "max-height": "160px" }
                        },
                        [
                          _c(
                            "v-card",
                            [
                              _c(
                                "v-list",
                                { attrs: { disabled: "", dense: "" } },
                                [
                                  _c(
                                    "v-list-item-group",
                                    { attrs: { color: "primary" } },
                                    _vm._l(_vm.missingParties, function(party) {
                                      return _c(
                                        "v-list-item",
                                        { key: party.id },
                                        [_vm._v(" " + _vm._s(party.name) + " ")]
                                      )
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mr-4 mb-2",
                              on: {
                                click: function($event) {
                                  _vm.missingPartiesModal = false
                                }
                              }
                            },
                            [_vm._v(" Cancel ")]
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "white--text mb-2",
                              attrs: { color: "warning" },
                              on: {
                                click: function($event) {
                                  return _vm.mergeWithWarning()
                                }
                              }
                            },
                            [_vm._v(" Merge Anyway ")]
                          ),
                          _c("v-spacer")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }